import 'devextreme/dist/css/dx.common.css'
/**
 * https://js.devexpress.com/Documentation/18_2/Guide/Themes_and_Styles/Predefined_Themes/
 * These styles are defined in public/index.html for switching to work
 */
//import 'devextreme/dist/css/dx.material.teal.dark.compact.css'
//import 'devextreme/dist/css/dx.material.teal.light.compact.css'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import './assets/fontawesome/fontawesome.css'
import './assets/global.css'
import { i18n } from './i18n'
import './global-components'
import { ErrorHandlerPlugin } from './plugins/error-handler'
import { AccessControlPlugin } from './plugins/access-control'
import { ToastPlugin } from './plugins/toast'
import { ConfirmPlugin } from './plugins/confirm'
import { getConnectionString } from './services/appInsights'
import AppInsightsPlugin from './plugins/appInsightsPlugin'
import Site24x7RumPlugin from './plugins/site24x7RumPlugin'

Vue.config.productionTip = false
Vue.config.ignoredElements = ['manage-licenses-modal']

Vue.use(ErrorHandlerPlugin)
Vue.use(AccessControlPlugin)
Vue.use(ToastPlugin)
Vue.use(ConfirmPlugin)

// Get the appropriate connection string based on environment
const connectionString = getConnectionString()

// Use the AppInsights plugin with the environment-specific connection string
Vue.use(AppInsightsPlugin, {
  connectionString: connectionString,
  serviceName: 'Portal-Web-Admin_FE',
})

// Use Site24x7 RUM plugin
Vue.use(Site24x7RumPlugin, {
  // Optional: Override app key for testing
  // appKeyOverride: 'your-test-key-here',

  // Optional: Override configuration
  config: {
    enableDebugLogs: process.env.NODE_ENV === 'development',
    captureErrors: true,
  },
})

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
